// extracted by mini-css-extract-plugin
export var animationSkeleton = "cc_rH";
export var skeleton = "cc_rG";